import React from "react";
import "./rateCardHeader.scss";

export const RateCardHeader = () =>{
    return(
        <div className="rate_card_header">
            <div className="container">
                <div className="heading_title"><h5>Rate Card</h5> <span className="badge">New</span></div>
            </div>
        </div>
    )
}